import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import Loader from '../Loader';
import { GlobalStyle } from '../../GlobalStyles';

const AuthWrapper = ({ children }) => {
  const { isLoading, error } = useAuth0();

  if (isLoading) {
    return (
      <>
        <div className='app-wrapper'>
          <Loader />
        </div>
        <GlobalStyle />
      </>
    );
  }
  if (error) {
    return (
      <>
        <div className='app-wrapper'>
          <h3>{error.message}</h3>
        </div>
        <GlobalStyle />
      </>
    );
  }

  return <>{children}</>;
};
export default AuthWrapper;
